<template>
  <div
    class="user-review-list-wrapper flex flex-col items-center py-20 xl:py-28 bg-white"
    data-test-id="component-user-review-list"
  >
    <div class="w-full grid grid-cols-12">
      <div class="flex flex-col col-span-12 items-start md:items-center px-8">
        <h3 class="font-druk font-medium text-display-14 md:text-display-14 uppercase leading-none" :style="{color: titleColor}">
          {{ title }}
        </h3>
        <div class="flex flex-row items-center leading-0 mt-1">
          <MajorityUiMajorityImage alt="star icon" class="h-12" src="https://majority.imgix.net/web-assets/svg/rating-star.svg" />
          <h3 class="font-druk font-medium text-display-14 md:text-display-14 uppercase text-infra-violette p-1">
            {{ rating }}
          </h3>
        </div>
      </div>
    </div>
    <BlocksNewCardCarousel class="w-full bg-white pt-0 mt-14" :per-page="3" :children="getReviews" :show-controls="true" @loaded="setCardWidth">
      <BlocksNewReviewCarouselItem v-for="(review, index) in getReviews" :key="index" :card-width="perCardWidth" v-bind="review" />
    </BlocksNewCardCarousel>
    <div class="flex mt-14">
      <div class="flex flex-row items-center px-5 border-r border-medium-grey">
        <MajorityUiMajorityImage alt="app store" :src="platforms[0].icon" class="grayscale brightness-0 h-[26px]" />
      </div>
      <div class="flex flex-row items-center px-5 border-r border-medium-grey">
        <MajorityUiMajorityImage alt="trustpilot" height="26px" :src="platforms[1].icon" class="grayscale brightness-0" />
      </div>
      <div class="flex flex-row items-center px-5">
        <MajorityUiMajorityImage alt="google play" height="26px" :src="platforms[2].icon" class="grayscale brightness-0" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { applicationContentStore } from '@/store/application/content'

const contentStore = applicationContentStore()
const locale = useLocale()
const props = defineProps({
  title: {
    type: String,
    default: () => ''
  },
  titleColor: {
    type: Object,
    default: () => {
      return {
        hex: 'black'
      }
    }
  },
  reviews: {
    type: Array,
    default: () => null
  },
  rating: {
    type: String,
    default: () => '4.8'
  }
})

const getReviews = computed(() => {
  return props.reviews || contentStore.getRandomReview(locale, 6)
})

const perCardWidth = ref('0px')

const setCardWidth = ({ cardWidth }) => {
  perCardWidth.value = (cardWidth - 16) + 'px'
}

const platforms = [
  {
    name: 'App Store',
    icon: 'https://majority.imgix.net/web-assets/svg/apple-store.svg'
  },
  {
    name: 'Trustpilot',
    icon: 'https://majority.imgix.net/web-assets/svg/trustp-icon.svg'
  },
  {
    name: 'Google Play',
    icon: 'https://majority.imgix.net/web-assets/svg/play-icon.svg'
  }
]

</script>
